module.exports = __webpack_public_path__ + "img/product.736f4890.svg";